import { render } from "./CashierDesk.vue?vue&type=template&id=cfeaca82&scoped=true"
import script from "./CashierDesk.vue?vue&type=script&lang=js"
export * from "./CashierDesk.vue?vue&type=script&lang=js"

import "./CashierDesk.vue?vue&type=style&index=0&id=cfeaca82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfeaca82"]])

export default __exports__